const ERROR_EN = Object.freeze({
  'error.validation.required': 'This field is required',
  'error.validation.email.format': 'Invalid email format',
  'error.validation.password.pattern': 'Password must be at least 8 characters and contain at least one number and one letter',
  'error.validation.confirm.password.mismatch': 'Passwords do not match, please re-enter',
  'error.validation.no.whitespace': 'String must not contain spaces',

  // Login
  'error.login.fail.title': 'Login Failed',
  'error.login.fail.description': 'Please check your username and password',

  // Forgot password
  'error.forgot-password.fail.title': 'Forgot Password Error',
  'error.forgot-password.fail.description': 'Please try again later',

  // Reset forgot password
  'error.reset-forgot-password.fail.title': 'Reset Password Error',
  'error.reset-forgot-password.fail.description': 'Please try again later',

  'error.common': 'An error occurred',
  'error.referral.INVALID_JWT_TOKEN': 'Invalid authentication token, please contact customer service',
  'error.referral.TOKEN_ALREADY_USED': 'Authentication token has already been used, please contact customer service',
});

export { ERROR_EN };
